// extracted by mini-css-extract-plugin
module.exports = {"salePrice":"currency-module__salePrice___3mQYM","originalPrice":"currency-module__originalPrice___2Eant","totalSale":"currency-module__totalSale___7P0bc"};